(() => {
  'use strict';
  document.querySelectorAll('[data-tgb-purchase-help]').forEach((widget) => {
    if (widget.dataset.ready) return;
    const gateway = widget.closest('[data-tgb-curated-gateway], [data-tgb-cyo-launcher]');
    if (!gateway) return;
    const curated = widget.dataset.mode === 'curated';
    const main = gateway.querySelector(curated ? '[data-tgb-fast-lane-open]' : '[data-tgb-cyo-launcher-link]');
    const builderLink = gateway.querySelector(curated ? '[data-tgb-customize-link]' : '[data-tgb-cyo-launcher-link]');
    if (!main || !builderLink) return;
    let variants;
    try { variants = JSON.parse(widget.querySelector('[data-tgb-purchase-variants]').textContent); } catch { return; }
    widget.dataset.ready = 'true';
    document.body.classList.add('tgb-product-ux-active');
    const scope = gateway.closest('section, .shopify-section') || document;
    const resume = widget.querySelector('[data-tgb-resume-banner]');
    const resumeLink = widget.querySelector('[data-tgb-resume-link]');
    const bar = widget.querySelector('[data-tgb-purchase-bar]');
    const action = widget.querySelector('[data-tgb-purchase-action]');
    const price = widget.querySelector('[data-tgb-purchase-price]');
    const controls = gateway.querySelector('.tgb-curated-gateway__choices') || main;
    const mobile = window.matchMedia('(max-width: 767px)');
    let activeVariant;
    let scheduled = false;

    function savedDraft() {
      try {
        const key = `tgb-${widget.dataset.mode}-draft-${widget.dataset.productId}-v10`;
        const state = JSON.parse(window.sessionStorage.getItem(key) || 'null');
        if (!state || state.schemaVersion !== 9 || !Array.isArray(state.checked)) return null;
        if (curated && String(state.containerVariantId) !== String(activeVariant.id)) return null;
        const hasChoices = state.checked.length > 0 || Number(state.maxStep) > 2 ||
          Boolean(state.ribbonLeft || state.ribbonRight || state.cardMessage || state.cardSignature);
        return hasChoices ? state : null;
      } catch { return null; }
    }

    function update() {
      scheduled = false;
      const input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      const variantId = input?.value || gateway.dataset.defaultVariantId;
      activeVariant = variants.find((variant) => variant.id === String(variantId)) || variants.find((variant) => variant.id === widget.dataset.defaultVariantId);
      if (!activeVariant) return;
      const available = Boolean(activeVariant.available);
      if (curated) main.disabled = !available;
      else {
        main.setAttribute('aria-disabled', String(!available));
      }
      action.disabled = !available;
      const label = available ? (curated ? widget.dataset.sendLabel : widget.dataset.buildLabel) : widget.dataset.soldLabel;
      if (action.textContent !== label) action.textContent = label;
      if (price.textContent !== activeVariant.price) price.textContent = activeVariant.price;
      const draft = savedDraft();
      resume.hidden = !draft || !available;
      if (draft) {
        const url = new URL(builderLink.href, window.location.origin);
        url.searchParams.set('variant', activeVariant.id);
        if (curated) url.searchParams.set('mode', 'curated');
        url.searchParams.set('builder_entry_source', 'saved_gift_resume');
        const current = new URL(window.location.href);
        ['preview_theme_id', 'preview_key', '_fd', 'pb'].forEach((key) => {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        });
        if (resumeLink.href !== url.href) resumeLink.href = url.href;
      }
      const editing = document.activeElement?.matches('input, textarea, select');
      const modalOpen = document.body.classList.contains('tgb-fast-lane-open') || document.body.classList.contains('tgb-container-modal-open');
      const show = mobile.matches && controls.getBoundingClientRect().bottom <= 0 && !modalOpen && !editing;
      bar.hidden = !show;
      document.body.classList.toggle('tgb-product-ux-bar-visible', show);
      const containerNote = gateway.querySelector('.tgb-product-ux-container-price');
      if (containerNote) {
        const next = `${widget.dataset.containerPrefix} · ${activeVariant.price}`;
        if (containerNote.textContent !== next) containerNote.textContent = next;
      }
    }

    function schedule() {
      if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); }
    }
    main.addEventListener('click', (event) => {
      update();
      if (!activeVariant?.available) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    action.addEventListener('click', () => {
      update();
      if (!activeVariant?.available) return;
      main.click();
      schedule();
    });
    resumeLink.addEventListener('click', () => {
      window.dataLayer?.push({event: 'tgb_saved_gift_resumed', builder_mode: widget.dataset.mode, product_id: widget.dataset.productId});
    });
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('change', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('variantChange', schedule);
    new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
    new MutationObserver(schedule).observe(builderLink, {attributes: true, attributeFilter: ['href']});
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
      new MutationObserver(schedule).observe(input, {attributes: true, attributeFilter: ['value']});
    });
    update();
  });
})();
